export const i18n = {
	defaultLocale: "en",
	locales: ["en", "de", "es-es", "es-mx", "fr", "it", "pt-br"],
} as const;

export type Locale = (typeof i18n)["locales"][number];
